import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9fe97d4a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "accounts-table-wrapper select-accounts"
};
const _hoisted_2 = {
  class: "accounts-table-wrapper"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "select-accounts"
}, "Select Specific Profiles", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "select-accounts-detail"
}, " From the list, choose the Amazon ads profiles to add to your workspace. ", -1));
const _hoisted_6 = {
  class: "table-body-product-text-wrapper"
};
const _hoisted_7 = {
  class: "table-body-product-text-wrapper"
};
const _hoisted_8 = {
  class: "table-body-product-text-wrapper"
};
const _hoisted_9 = {
  class: "table-body-product-text-wrapper"
};
const _hoisted_10 = {
  class: "table-body-product-text-wrapper"
};
const _hoisted_11 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_page_title = _resolveComponent("app-page-title");
  const _component_connection_failed = _resolveComponent("connection-failed");
  const _component_app_table_head = _resolveComponent("app-table-head");
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
  const _component_app_td = _resolveComponent("app-td");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_b_tbody = _resolveComponent("b-tbody");
  const _component_b_table_simple = _resolveComponent("b-table-simple");
  const _component_connection_success = _resolveComponent("connection-success");
  return _openBlock(), _createElementBlock(_Fragment, null, [$data.loadingData ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Loading Profiles Data... ")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [!$data.showSuccessMessage && !$data.showFailedMessage ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_app_page_title, {
    title: 'Choose Amazon Ads Accounts',
    action: "Validate",
    onAction: $options.onValidate,
    visibleButton: true
  }, null, 8, ["onAction"]), _hoisted_4, _hoisted_5])) : _createCommentVNode("", true), $data.showFailedMessage ? (_openBlock(), _createBlock(_component_connection_failed, {
    key: 1
  })) : _createCommentVNode("", true), _createVNode(_component_b_table_simple, {
    "sticky-header": "",
    striped: "",
    "table-class": "accounts-table table-wrapper "
  }, {
    default: _withCtx(() => [_createVNode(_component_app_table_head, {
      fields: $options.tableFields,
      onSelectAll: $options.selectAll
    }, null, 8, ["fields", "onSelectAll"]), _createVNode(_component_b_tbody, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.accounts, item => {
        return _openBlock(), _createBlock(_component_b_tr, {
          key: item.seller_id,
          onClick: $event => $options.onRowSelect(item)
        }, {
          default: _withCtx(() => [_createVNode(_component_app_td, {
            class: "table-body-checkbox-wrapper border-table-row"
          }, {
            default: _withCtx(() => [!$data.showFailedMessage ? (_openBlock(), _createBlock(_component_b_form_checkbox, {
              key: 0,
              modelValue: item.isSelected,
              "onUpdate:modelValue": $event => item.isSelected = $event,
              disabled: $options.selectedAccounts.length >= $data.selectLimit && !item.isSelected
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1024), _createVNode(_component_app_td, {
            class: "table-body-product-wrapper border-table-row"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1)]),
            _: 2
          }, 1024), _createVNode(_component_app_td, {
            class: "table-body-product-wrapper border-table-row"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, _toDisplayString(item.seller_id), 1)]),
            _: 2
          }, 1024), _createVNode(_component_app_td, {
            class: "table-body-product-wrapper border-table-row"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_8, _toDisplayString(item.account_id), 1)]),
            _: 2
          }, 1024), _createVNode(_component_app_td, {
            class: "table-body-product-wrapper border-table-row"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_9, _toDisplayString(item.marketplace_id), 1)]),
            _: 2
          }, 1024), _createVNode(_component_app_td, {
            class: "table-body-product-wrapper border-table-row",
            align: "center"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.getCountry(item.marketplace_id)), 1), _createElementVNode("img", {
              class: "country-flag flag-wrapper",
              src: $options.getFlagForMarketPlace(item.marketplace_id),
              alt: item.marketplace_id
            }, null, 8, _hoisted_11)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))]),
      _: 1
    })]),
    _: 1
  }), $data.showSuccessMessage ? (_openBlock(), _createBlock(_component_connection_success, {
    key: 2
  })) : _createCommentVNode("", true)])], 64);
}